// cookie domain for activity timeout
export const getCookieDomain = (hostname: string): string | undefined => {
  const parts = hostname.split('.');
  // handle localhost/dev
  if (parts.length < 2) return undefined;
  // Add more logic here if needed for special cases (e.g., multi-level TLDs)
  return '.' + parts.slice(-2).join('.');
};
